import { Header } from "@tanstack/react-table";
import { TFunction } from "i18next";
import { isValidElement } from "react";

/**
 * Extracts plain text from a table header.
 */
export function getHeaderTextValue<TData>(
  header: Header<TData, unknown>,
  t: TFunction,
): string {
  if (header.isPlaceholder) return "";

  const def = header.column.columnDef.header;

  if (typeof def === "string") {
    return t(def);
  }

  if (typeof def === "function") {
    try {
      const result = def(header.getContext());

      if (typeof result === "string") {
        return result;
      }
      if (typeof result === "number") {
        return String(result);
      }
      if (result == null || isValidElement(result)) {
        return "";
      }
      return String(result);
    } catch {
      return "";
    }
  }

  return header.column.id;
}
